import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    padding: '8px 0',
  },
  availableTitle: {
    fontWeight: 600,
    marginBottom: 12,
    color: '#000',
    fontSize: '15px'
  },
  carouselShell: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    position: 'relative',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    }
  },
  arrowButton: {
    background: '#000',
    color: '#fff',
    minWidth: '24px !important',
    width: '24px',
    height: '24px',
    padding: '4px',
    borderRadius: '50%',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { 
      background: '#333',
    },
    '& svg': {
      fontSize: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  cardsScroller: {
    display: 'flex',
    gap: 12,
    overflowX: 'auto',
    padding: '4px 2px',
    scrollBehavior: 'smooth',
    WebkitOverflowScrolling: 'touch',
    flex: 1,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none', // Firefox
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      overflowX: 'visible',
      gap: 12,
    }
  },
  vehicleCard: {
    flex: '0 0 calc(33.333% - 8px)',
    minWidth: 'calc(33.333% - 8px)',
    background: '#fff',
    borderRadius: 8,
    padding: '8px 6px',
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.2s ease',
    border: '1px solid transparent',
    position: 'relative',
    boxSizing: 'border-box',
    '&:hover': {
      borderColor: '#dcdcdc',
    },
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
      width: '100%',
      minWidth: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: '16px',
      textAlign: 'left',
    }
  },
  vehicleCardActive: {
    background: '#f8f9fa',
    border: '1px solid #000',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1) !important',
    transform: 'none',
    position: 'relative',
    boxSizing: 'border-box',
    '&:hover': {
      borderColor: '#ccc',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    },
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
      width: '100%',
      minWidth: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: '16px',
      textAlign: 'left',
    }
  },
  cardImageWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      marginRight: 16,
      height: 40,
      width: 60,
    }
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  cardBody: {
    width: '100%',
    textAlign: 'left',
    marginTop: 6,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flex: 1,
    }
  },
  cardTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#333',
    marginBottom: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
    }
  },
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 4,
  },
  cardMeta: {
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 9,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    }
  },
  seats: {
    opacity: 0.8,
    marginLeft: 2,
  },
  cardPrice: {
    fontWeight: 700,
    color: '#000',
    fontSize: '14px',
    marginTop: 2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      position: 'absolute',
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      marginTop: 0,
    }
  },
}));

export default useStyles;
